// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"09d2f687","861":"c4f3dc0e"}[chunkId] + ".chunk.js");